import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { Routes } from '@angular/router';
import { PermissionResponse } from '../core/base-api';
import { GeometergeschaeftRoutes } from './geometergeschaeft/geometergeschaeft.routes';
import { GebaeudeRoutes } from './gebaeude/gebaeude.routes';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const VermessungRoutes: Routes = [
  {
    path: 'vermessung',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN]
    },
    children: [...GeometergeschaeftRoutes, ...GebaeudeRoutes]
  }
];
